import { BreadCrumbs } from '@employ-engage/common-components';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface AdminFormTemplatesViewWrapperProps {}

export function AdminFormTemplatesViewWrapper(
  props: AdminFormTemplatesViewWrapperProps
) {
  const { t } = useTranslation(['common']);
  return (
    <>
      <BreadCrumbs
        pages={[{ name: t('Form Templates'), to: '/admin/form-templates' }]}
        className="mb-3.5"
      />
      <Outlet />
    </>
  );
}

export default AdminFormTemplatesViewWrapper;
